/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { useAmp } from 'next/amp';

const Loading = ({ mobile, desktop }) => {
  const { isMobile } = useDeviceScreen();
  const isAmp = useAmp();
  const width = (isAmp || isMobile) ? mobile.width : desktop.width;
  const height = (isAmp || isMobile) ? mobile.height : desktop.height;

  return !isMobile ? (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="413" rx="0" ry="0" width="240" height="167" />
      <rect x="245" y="413" rx="0" ry="0" width="240" height="167" />
      <rect x="490" y="413" rx="0" ry="0" width="240" height="167" />
      <rect x="735" y="413" rx="0" ry="0" width="240" height="167" />
      <rect x="490" y="240" rx="0" ry="0" width="240" height="167" />
      <rect x="735" y="240" rx="0" ry="0" width="240" height="167" />
      <rect x="490" y="67" rx="0" ry="0" width="240" height="167" />
      <rect x="735" y="67" rx="0" ry="0" width="240" height="167" />
      <rect x="0" y="67" rx="0" ry="0" width="484" height="340" />
      <rect x="0" y="29" rx="0" ry="0" width="700" height="26" />
    </ContentLoader>
  ) : (
    <ContentLoader
      speed={9}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="0" y="0" rx="0" ry="0" width="492" height="249" />
      <rect x="0" y="254" rx="0" ry="0" width="236" height="178" />
      <rect x="242" y="254" rx="0" ry="0" width="241" height="178" />
    </ContentLoader>
  );
};

Loading.propTypes = {
  mobile: PropTypes.object,
  desktop: PropTypes.object,
};

export default Loading;
